import ReactDOM from 'react-dom/client'
import '/node_modules/react-grid-layout/css/styles.css'
import '/node_modules/react-resizable/css/styles.css'
import './App.scss'
import App from "./App.tsx"
import { defaultQueryFn } from "./api/defaultQuery.ts"
import { getErrorCode } from "./api/handleResponse.ts"

import { QueryClient, QueryClientProvider } from "@tanstack/react-query"

const queryClient = new QueryClient()

queryClient.setDefaultOptions({
    queries: {
        queryFn: defaultQueryFn,
        staleTime: Infinity,
        // A 4xx (session ended, no plan, bad input) won't change on retry; only retry server/network errors
        retry: (failureCount, error) => {
            const status = Number(getErrorCode(error))
            return !(status >= 400 && status < 500) && failureCount < 3
        },
    },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
    <QueryClientProvider client={queryClient}>
        <App/>
    </QueryClientProvider>
)
